module.exports = __webpack_public_path__ + "Inter-Medium.woff2?c6fde2a92fa6723f27876d1398672e99";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Inter-woff2/Inter-Medium.woff2
// module id = 532
// module chunks = 289